export default __webpack_public_path__ + "static/media/avatar_3.ffce5365.png";